// Choco Drizzle only. Keep both purchase controls honest when stock is absent.
(() => {
  const sync = form => {
    const selected = form.querySelector('[data-variant-option]:checked') || form.querySelector('[data-variant-option]');
    const button = form.querySelector('.dpdp-form__add');
    if (!selected || !button || button.classList.contains('is-loading')) return;
    button.disabled = selected.disabled;
    const label = button.querySelector('span') || button;
    label.textContent = selected.disabled ? 'Sold out' : 'Add to cart · ' + selected.dataset.price;
  };
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-product-form]').forEach(sync));
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-option]')) sync(event.target.closest('[data-product-form]'));
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    const selected = form.querySelector('[data-variant-option]:checked') || form.querySelector('[data-variant-option]');
    if (!selected || selected.disabled) {
      event.preventDefault(); event.stopImmediatePropagation(); sync(form);
    }
  }, true);
})();
